var PageNotFoundComponent = (function () {
    function PageNotFoundComponent() {
    }
    return PageNotFoundComponent;
}());
export { PageNotFoundComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/not-found.component.ts.pre-build-optimizer.js